import { Badge } from '../Badge';

export class BadgeDownloader {
  private static generateUrlFromBlob(blob: Blob) {
    return URL.createObjectURL(blob);
  }

  static downloadBlobFile(blob: Blob | undefined, fileName: string) {
    try {
      if (!blob) throw new Error('No blob provided');
      return new Promise(async (accept) => {
        const url = this.generateUrlFromBlob(blob);
        const base64 = await Badge.blobToBase64(blob);
        if (base64) {
          const img = new Image();
          img.src = (await Badge.blobToBase64(blob))!;
        }

        if (!document) {
          return;
        }

        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('target', '_blank');
        link.style.display = 'none';
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        accept({});
      });
    } catch (e) {
      console.log(e);
    }
  }
}
